
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.327 15.285l-3.236-3.235 3.237-3.237a.737.737 0 00-1.042-1.041l-3.236 3.236-3.237-3.237A.737.737 0 007.77 8.813l3.237 3.237-3.236 3.236a.737.737 0 101.041 1.042l3.237-3.237 3.235 3.236a.737.737 0 001.042-1.042z","fill":"currentColor"}})])
          )
        }
      }
    